import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'ramda/src/isNil';
import moment from 'moment';
import CheckBox from '@components/@core/CheckBox';
import Pagination from '@components/@core/Pagination';
import Thumbnail from '@components/@core/Thumbnail';
import EditDropdown from '@components/EditDropdown';
import { UserRoles } from '~/services/config';
import { inPage } from '~/services/util';

class Course extends React.PureComponent {
    state = { current: 1, per: 5 };

    handlePagination = (current) => {
        this.setState({ current });
    };

    handlePer = (per) => {
        if (per >= 10) {
            this.setState({ current: 1, per });
        }
        this.setState({ per });
    };

    renderStatus(status, completed_at) {
        if (status === 0) {
            return <span className="dsl-b14 text-400 text-nowrap">Not Started</span>;
        } else if (status === 3) {
            return (
                <div>
                    <span className="dsl-b14 text-400 text-nowrap">Completed</span>
                    <br />
                    <span className="dsl-m12 text-nowrap">{moment(completed_at).format('M/D/YYYY')}</span>
                </div>
            );
        } else if (status === 2) {
            return <span className="dsl-b14 text-400 text-nowrap">Past Due</span>;
        } else {
            return <span className="dsl-b14 text-400 text-nowrap">In Progress</span>;
        }
    }

    render() {
        const { current, per } = this.state;
        const { data, type, userRole, onSelectMenu } = this.props;
        const dotsMenu = ['Edit', 'Unassign'];

        return (
            <>
                <div className="report-item desktop-screen">
                    <div className="d-flex-10 text-start">
                        <span className="dsl-m12">Courses</span>
                    </div>
                    <div className="d-flex-2 text-end">
                        <span className="dsl-m12">Modules</span>
                    </div>
                    <div className="d-flex-2 text-end">
                        <span className="dsl-m12">Completed</span>
                    </div>
                    <div className="d-flex-2 text-end">
                        <span className="dsl-m12">Open</span>
                    </div>
                    <div className="d-flex-3 text-end">
                        <span className="dsl-m12">Due date</span>
                    </div>
                    <div className="d-flex-3 text-start ms-3">
                        <span className="dsl-m12">Status</span>
                    </div>
                    {userRole < UserRoles.MANAGER && <div className="d-flex-1" />}
                </div>
                {data.length === 0 ? (
                    <p className="dsl-m14 mt-3">{`There are no ${type} assigned courses.`}</p>
                ) : (
                    data.map((item, index) => {
                        const completed = item.children_complete;
                        const total = item.children.length;
                        const opened = total - completed;
                        const isCompleted = total > 0 ? completed === total : false;
                        const percent_completed = item.percent_complete;
                        const percent_opened = 100 - percent_completed;
                        const due_date = isNil(item.due_at) ? 'N/A' : moment(item.due_at).format('MMM D');
                        return (
                            inPage(index, current, per) && (
                                <div className="report-item d-flex ssm-column" key={`card${index}`}>
                                    <div className="d-flex d-flex-10 text-start">
                                        <div className="d-flex align-items-center">
                                            <CheckBox checked={isCompleted} />
                                        </div>
                                        <Thumbnail className="mx-2" source={item.data.thumb_url} size="tiny" />
                                        <p className={`dsl-b14 text-400 truncate-two mb-0 ${isCompleted ? 'text-line-through' : ''}`}>{item.data.name}</p>
                                        {userRole < UserRoles.MANAGER && (
                                            <div className="d-flex-1 edit d-sm-none">
                                                <EditDropdown options={dotsMenu} onChange={(e) => onSelectMenu(item, e)} />
                                            </div>
                                        )}
                                    </div>
                                    <div className="d-flex-2 d-flex d-sm-block text-end ssm-left py-1 py-sm-0">
                                        <span className="dsl-b14 w-30 text-400 mobile-screen">Module</span>
                                        <span className="dsl-b14 text-400">{total}</span>
                                        <br />
                                        <span className="dsl-m12 ms-2">100%</span>
                                    </div>
                                    <div className="d-flex-2 d-flex d-sm-block text-end ssm-left py-1 py-sm-0">
                                        <span className="dsl-b14 w-30 text-400 mobile-screen">Completed</span>
                                        <span className="dsl-b14 text-400">{completed}</span>
                                        <br />
                                        <span className="dsl-m12 ms-2">{percent_completed}%</span>
                                    </div>
                                    <div className="d-flex-2 d-flex d-sm-block text-end ssm-left py-1 py-sm-0">
                                        <span className="dsl-b14 w-30 text-400 mobile-screen">Open</span>
                                        <span className="dsl-b14 text-400">{opened}</span>
                                        <br />
                                        <span className="dsl-m12 ms-2">{percent_opened}%</span>
                                    </div>
                                    <div className="d-flex-3 d-flex d-sm-block text-end ssm-left py-2 py-sm-0">
                                        <span className="dsl-b14 w-30 text-400 mobile-screen">DueDate</span>
                                        <span className="dsl-b14 text-400">{due_date}</span>
                                    </div>
                                    <div className="d-flex-3 d-flex d-sm-block text-start ms-3 ssm-l-0 py-2 py-sm-0">
                                        <span className="dsl-b14 w-30 text-400 mobile-screen">Status</span>
                                        {this.renderStatus(item.status, item.completed_at)}
                                    </div>
                                    {userRole < UserRoles.MANAGER && (
                                        <div className="d-flex-1 edit desktop-screen">
                                            <EditDropdown options={dotsMenu} onChange={(e) => onSelectMenu(item, e)} />
                                        </div>
                                    )}
                                </div>
                            )
                        );
                    })
                )}
                <Pagination size="small" current={current} per={per} pers={[5, 10, 'all']} total={Math.ceil(data.length / per)} onChange={this.handlePagination} onPer={this.handlePer} />
            </>
        );
    }
}

Course.propTypes = {
    count: PropTypes.number.isRequired,
    data: PropTypes.array.isRequired,
};

Course.defaultProps = {
    count: 0,
    data: [],
};

export default Course;
